
import { state } from "@/store/modules/notifications/state";
import mutations from "@/store/modules/notifications/mutations"
import actions from "@/store/modules/notifications/actions"
import getters from "@/store/modules/notifications/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}